module.exports = __webpack_public_path__ + "static/media/addData.edd26b39.svg";